import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as Base } from 'antd';

/**
 * 气泡展示
 */
function Tooltip(props) {
  const { content, target, children, trigger, position, ...others } = props;
  return (
    <Base
      prefixCls="tooltip"
      trigger={trigger}
      title={content}
      // arrowContent={<div className="tooltip-arrow-inner" />}
      placement={position}
      {...others}
    >
      {target || children}
    </Base>
  );
}
Tooltip.defaultProps = {
  trigger: 'hover',
  position: 'right'
};
Tooltip.propTypes = {
  /** 气泡内容 */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** 触发气泡的元素，默认为children */
  target: PropTypes.element,
  /** 触发方式 */
  trigger: PropTypes.oneOf(['hover', 'click']),
  /** 内容的位置 */
  position: PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left',
    'topLeft',
    'topRight',
    'rightTop',
    'rightBottom',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom'
  ])
};
export default Tooltip;
